// import React from "react";
// import { Box, Typography, Button, Container, keyframes } from "@mui/material";
// import { Link } from "react-router-dom";


// import heroVideo from '../assets/images/Truck.mp4';

// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform:translateX(100px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const fadeIn = keyframes`
//   from {
//     opacity: 0;
//   }
//   to {
//     opacity: 1;
//   }
// `;

// export default function HeroSection() {
//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         minHeight: { xs: '70vh', md: '100vh' },
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         textAlign: 'center',
//         overflow: 'hidden',
//       }}
//     >
//       {/* Background Video */}
//       <Box
//         component="video"
//         autoPlay
//         muted
//         loop
//         playsInline
//         // src="/videos/hero-bg.mp4" 
//         src={heroVideo} 
//         sx={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           minWidth: '100%',
//           minHeight: '100%',
//           objectFit: 'cover',
//           zIndex: 0,
//         }}
//       />

//       {/* Overlay */}
//       <Box
//         sx={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           background: 'rgba(0,0,0,0.5)',
//           zIndex: 1,
//         }}
//       />

//       {/* Content */}
//       <Container sx={{ position: 'relative', zIndex: 2 }} maxWidth="md">
//         <Typography
//           variant="h3"
//           component="h1"
//           gutterBottom
//           sx={{
//             color: '#7AB2D3',
//             fontWeight: 700,
//             textShadow: '1px 1px 4px rgba(0,0,0,0.6)',
//             animation: `${fadeInUp} 1s ease-out forwards`,
//             fontFamily:'Merriweather, serif',
//           }}
//         >
//           Innovative Solutions for Your Business
//         </Typography>
//         <Typography
//           variant="h6"
//           paragraph
//           sx={{
//             color: '#fff',
//             textShadow: '1px 1px 3px rgba(0,0,0,0.5)',
//             animation: `${fadeInUp} 1.5s ease-out forwards`,
//           }}
//         >
//           We deliver cutting-edge technology and smart software tailored to your needs.
//         </Typography>
//         <Button
//           component={Link}
//           to="/contact"
//           variant="contained"
//           size="large"
//           sx={{
//             mt: 4,
//             px: 5,
//             py: 1.5,
//             borderRadius: 10,
//             backgroundColor: '#7AB2D3',
//             color: '#fff',
//             fontWeight: 'bold',
//             animation: `${fadeIn} 2s ease-out forwards`,
//             '&:hover': {
//               backgroundColor: '#4A628A',
//             },
//           }}
//         >
//           GET STARTED
//         </Button>
//       </Container>
//     </Box>
//   );
// }


// HeroSection.jsx
import React from "react";
import { Box, Button, Typography, Stack } from "@mui/material";
import { Link } from 'react-router-dom';
import fleetMapVideo from '../assets/videos/herovideo.mp4';

const HeroSection = () => {
  return (
    <Box sx={{ position: "relative", height: "100vh", overflow: "hidden" }}>
      {/* 🔹 Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
          opacity: 0.6,
        }}
      >
    
        <source src={fleetMapVideo} type="video/mp4" />
        
        Your browser does not support the video tag.
      </video>

      {/* 🔸 Content Over Video */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 4,
          textAlign: "center",
          color: "#fff",
          background: "linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.2))",
        }}
      >
        <Box maxWidth="md">
          <Typography variant="h2" fontWeight="bold" gutterBottom fontFamily="Merriweather, serif"
              // fontFamily={'Merriweather, serif'}
          >
            Smart Fleet. Smarter Business.
          </Typography>
          <Typography variant="h6" mb={4} fontFamily="Merriweather, serif">
            Track, manage, and optimize your fleet operations in real-time with Claysoft’s powerful logistics platform.
          </Typography>

          {/* 🔘 CTA Buttons */}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
            <Link to="/services">
            <Button variant="contained" color="primary" size="large" >
              ▶ Watch Demo
            </Button>
            </Link>
           <Link to="/contact">
  <Button
    variant="outlined"
    color="inherit"
    size="large"
    sx={{
      transition: 'all 0.3s ease',
      borderColor: '#fff',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#7AB2D3',
        color: '#000',
        borderColor: '#7AB2D3',
      },
    }}
  >
    Request a Free Trial
  </Button>
</Link>

          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;
